import React from 'react';
import { Check, ArrowRight, ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
export function OfferStackSection() {
  const offers = [{
    image: 'https://cdn.magicpatterns.com/uploads/wVRK9J8FPb4GXsuRe9s9aA/Masterkit_IA.jpg',
    title: '📘 MASTERKIT IA: El Sistema Completo',
    subtitle: 'La Guía Paso a Paso de 0 a Experto',
    value: '$47.00',
    description: 'No es un libro teórico. Es un sistema de implementación rápida para dominar la Inteligencia Artificial sin conocimientos técnicos. Aprende a delegar tu trabajo aburrido a la máquina.',
    features: ['Ingeniería de Prompts: Aprende a "hablar" con la IA.', 'Redacción Automática de Emails y Reportes.', 'Estrategias de productividad que ahorran 10h/semana.'],
    isBonus: false
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/u5oY4fxavRmGN1wZmJEkoc/Bono_1.png',
    title: '🎁 BONO 1: La Biblia de Prompts',
    subtitle: '50+ Comandos Probados para Negocios',
    value: '$27.00',
    description: 'Deja de pelear con el chat. Hemos creado la biblioteca definitiva de comandos que funcionan a la primera. Solo tienes que copiar, pegar y ver los resultados.',
    features: ['Prompts para Marketing, Ventas y RRHH.', 'Guiones para cerrar clientes y rebatir objeciones.', 'Estructuras virales para redes sociales.'],
    isBonus: true
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/1qHW5PTXMnNqdycr8kB5dZ/Bono_2.png',
    title: '🛠️ BONO 2: Toolbox Secreta',
    subtitle: 'Las 20 Mejores Herramientas Gratuitas',
    value: '$19.00',
    description: 'No necesitas pagar suscripciones caras. Hemos curado una lista con las mejores herramientas de IA gratuitas que casi nadie conoce para diseñar, editar audio y organizar.',
    features: ['Alternativas gratis a Midjourney y Photoshop.', 'Herramientas de voz y audio profesional.', 'Generadores de presentaciones en segundos.'],
    isBonus: true
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/uL2ucBBgT4GNySLrMo8Lh9/Bono_3.png',
    title: '✅ BONO 3: Checklist de Automatización',
    subtitle: 'Tu Hoja de Ruta Diaria',
    value: '$9.00',
    description: 'La consistencia es la clave. Usa esta hoja de verificación diaria para asegurarte de que estás delegando lo correcto y no cayendo en viejos hábitos manuales.',
    features: ['Rutina de mañana de 10 minutos.', 'Sistema de priorización de tareas.', 'Formato listo para imprimir.'],
    isBonus: true
  }];
  return <section className="py-24 bg-black/20 relative overflow-hidden" data-id="element-139">
      <div className="container mx-auto px-4" data-id="element-140">
        {/* Encabezado */}
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-141">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-142">
            ESTO ES LO QUE <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-600" data-id="element-143">RECIBES HOY</span>
          </h2>
          <p className="text-xl text-gray-400" data-id="element-144">
            Un arsenal digital valorado en <span className="text-red-400 line-through font-bold" data-id="element-145">$102</span>.
          </p>
        </div>

        {/* Lista de Productos (Stack) */}
        <div className="max-w-5xl mx-auto space-y-8 mb-16" data-id="element-146">
          {offers.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: "-50px"
        }} transition={{
          delay: index * 0.1
        }} className={`relative rounded-3xl overflow-hidden border flex flex-col md:flex-row ${item.isBonus ? 'border-cyan-500/30 bg-gradient-to-r from-[#0a1628] to-[#050505]' : 'border-blue-500/50 bg-[#0f172a] shadow-2xl shadow-blue-900/20'}`} data-id="element-147">
              {item.isBonus && <div className="absolute top-0 right-0 bg-cyan-600 text-white text-xs font-bold px-4 py-1 rounded-bl-xl z-20" data-id="element-148">
                  BONO DE REGALO
                </div>}

              <div className="w-full md:w-1/3 p-6 md:p-8 flex items-center justify-center bg-black/20" data-id="element-149">
                <div className="relative aspect-square md:aspect-[4/3] w-full max-w-[200px] md:max-w-none rounded-xl overflow-hidden bg-black/40 border border-white/5 group" data-id="element-150">
                  <img src={item.image} alt={item.title} className="w-full h-full object-contain p-2 group-hover:scale-105 transition-transform duration-500" data-id="element-151" />
                </div>
              </div>

              <div className="flex-1 p-6 md:p-8 pt-0 md:pt-8 text-left" data-id="element-152">
                <div className="flex flex-col md:flex-row justify-between items-start mb-4" data-id="element-153">
                  <div data-id="element-154">
                    <h3 className="text-2xl font-bold text-white mb-1" data-id="element-155">
                      {item.title}
                    </h3>
                    <p className="text-cyan-400 font-medium text-sm md:text-base" data-id="element-156">
                      {item.subtitle}
                    </p>
                  </div>
                  
                  <div className="text-right hidden md:block min-w-[100px]" data-id="element-157">
                    <span className="block text-xs text-gray-500 uppercase font-bold" data-id="element-158">Valor Real</span>
                    <span className="text-xl font-bold text-red-400 line-through" data-id="element-159">{item.value}</span>
                  </div>
                </div>
                
                <p className="text-gray-300 mb-6 leading-relaxed text-sm md:text-base border-b border-white/10 pb-6" data-id="element-160">
                  {item.description}
                </p>

                <ul className="space-y-3" data-id="element-161">
                  {item.features && item.features.map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-162">
                      <div className="mt-1 bg-cyan-500/20 p-1 rounded-full flex-shrink-0" data-id="element-163">
                         <Check className="w-3 h-3 text-cyan-400" data-id="element-164" />
                      </div>
                      <span className="text-gray-400 text-sm" data-id="element-165">{feature}</span>
                    </li>)}
                </ul>
                
                 <div className="mt-6 flex items-center gap-2 md:hidden border-t border-white/5 pt-4" data-id="element-166">
                    <span className="text-sm text-gray-500 uppercase font-bold" data-id="element-167">Valor:</span>
                    <span className="text-lg font-bold text-red-400 line-through" data-id="element-168">{item.value}</span>
                    {item.isBonus && <span className="ml-auto text-cyan-400 font-bold text-sm" data-id="element-169">GRATIS</span>}
                 </div>
              </div>
            </motion.div>)}
        </div>

        {/* --- NUEVO BOTÓN DE COMPRA AGREGADO AQUÍ --- */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center mt-12" data-id="element-170">
          <div className="inline-block p-1 rounded-full bg-gradient-to-r from-green-400 via-cyan-500 to-blue-600 shadow-[0_0_40px_-10px_rgba(34,211,238,0.4)]" data-id="element-171">
            <button className="px-10 py-5 rounded-full bg-white text-black font-black text-lg md:text-2xl hover:scale-[1.02] transition-transform flex items-center justify-center gap-3 w-full md:w-auto" data-id="element-172">
              OBTENER ACCESO INMEDIATO - $19.99
              <ArrowRight className="w-6 h-6" data-id="element-173" />
            </button>
          </div>
          <div className="flex items-center justify-center gap-2 mt-4 text-gray-400 text-sm" data-id="element-174">
            <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-175" />
            <span data-id="element-176">Pago Único • Sin Suscripciones • Acceso de por vida</span>
          </div>
        </motion.div>

      </div>
    </section>;
}